import { lazyWithRetry } from '@/pages/lazy';

export const StockLevels = lazyWithRetry(() =>
  import('./StockLevels').then((m) => ({ default: m.StockLevels })),
);
export const MaterialStockDetail = lazyWithRetry(() =>
  import('./MaterialStockDetail').then((m) => ({
    default: m.MaterialStockDetail,
  })),
);

export const StockPurchases = lazyWithRetry(() =>
  import('./StockPurchases').then((m) => ({ default: m.StockPurchases })),
);
export const NewStockPurchase = lazyWithRetry(() =>
  import('./NewStockPurchase').then((m) => ({ default: m.NewStockPurchase })),
);
export const PurchaseDetails = lazyWithRetry(() =>
  import('./PurchaseDetails').then((m) => ({ default: m.PurchaseDetails })),
);
export const UsagePage = lazyWithRetry(() =>
  import('./UsagePage').then((m) => ({ default: m.UsagePage })),
);
export const StockTransfers = lazyWithRetry(() =>
  import('./StockTransfers').then((m) => ({ default: m.StockTransfers })),
);
export const StockCount = lazyWithRetry(() =>
  import('./StockCount').then((m) => ({ default: m.StockCount })),
);
export const SuppliersPage = lazyWithRetry(() =>
  import('./SuppliersPage').then((m) => ({ default: m.SuppliersPage })),
);
export const SupplierDetailsPage = lazyWithRetry(() =>
  import('./SupplierDetailsPage').then((m) => ({
    default: m.SupplierDetailsPage,
  })),
);
